import { deleteImpactCo2AnswerVenueDate } from '@/domain/impact-co2/actions/venue/delete-impact-co2-answer-venue-date.action';
import { submitImpactCo2AnswerVenueDate } from '@/domain/impact-co2/actions/venue/submit-impact-co2-answer-venue-date.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';

export function useCo2DayQuizSubmitAnswer(dateId: number) {
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectVenue);
  const projectId = project?.id || -1;

  const onSubmit = (answer: ImpactCo2Answer) => {
    dispatch(
      submitImpactCo2AnswerVenueDate({
        projectId,
        dateId,
        answer,
        submitMode: 'create',
      }),
    );
  };

  const onEdit = (answer: ImpactCo2Answer) => {
    dispatch(
      submitImpactCo2AnswerVenueDate({
        projectId,
        dateId,
        answer,
        submitMode: 'edit',
      }),
    );
  };

  const onDelete = (answer: ImpactCo2Answer) => {
    dispatch(
      deleteImpactCo2AnswerVenueDate({
        projectId,
        dateId,
        answer,
      }),
    );
  };

  return { onSubmit, onEdit, onDelete };
}
